import type { SxStyle } from "../../leads/heatStyles.js";

/**
 * Shared cell + header-cell `sx` for the leads table, extracted from
 * `LeadsTable.tsx` so the row, the cells, the sortable header, and the table
 * shell all reference one definition.
 */

export const cellSx: SxStyle = { px: 1.5, py: 1, fontSize: 14, verticalAlign: "middle", borderBottom: 0 };

export const headCellSx: SxStyle = {
  px: 1.5,
  py: 1,
  fontSize: 10,
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  color: "text.disabled",
  borderBottom: 0,
};
